import React from 'react'
import { Transition, TransitionGroup } from 'react-transition-group'

const DURATION = 250

const containerStyle: React.CSSProperties = {
  display: 'grid',
}

const childStyle: React.CSSProperties = {
  gridArea: '1 / 1',
}

const styles: Record<string, React.CSSProperties> = {
  entering: {
    ...childStyle,
    opacity: 0,
  },
  entered: {
    ...childStyle,
    transition: `opacity ${DURATION}ms ease-in`,
    opacity: 1,
  },
  exiting: {
    ...childStyle,
    transition: `opacity ${DURATION}ms ease-out`,
    opacity: 0,
  },
  exited: {
    ...childStyle,
    opacity: 0,
  },
}

type GentlyAppearProps = {
  children?: React.ReactNode
  location?: { pathname: string }
}

export const GentlyAppear = ({ children, location = { pathname: String(Math.random()) } }: GentlyAppearProps) => (
  <TransitionGroup style={containerStyle}>
    <Transition
      key={location.pathname}
      timeout={{
        enter: DURATION,
        exit: DURATION,
      }}
    >
      {(status) => <div style={{ ...styles[status] }}>{children}</div>}
    </Transition>
  </TransitionGroup>
)
